export class BaseRenderer {
  constructor(canvas) {
    this.canvas = canvas;
    this.width = canvas.width;
    this.height = canvas.height;
  }

  clearScene() {
    throw new Error('clearScene must be implemented by subclass');
  }

  renderEntity(entity) {
    throw new Error('renderEntity must be implemented by subclass');
  }

  renderEntities(soldiers, projectiles, corpses = [], bases = [], resources = []) {
    throw new Error('renderEntities must be implemented by subclass');
  }

  renderDebugInfo(soldiers, projectiles, bases) {
    throw new Error('renderDebugInfo must be implemented by subclass');
  }

  resize(width, height) {
    this.width = width;
    this.height = height;
  }

  render(soldiers, projectiles, corpses = [], bases = [], resources = []) {
    this.clearScene();
    this.renderEntities(soldiers, projectiles, corpses, bases, resources);
    return this.renderDebugInfo(soldiers, projectiles, bases);
  }

  getRendererType() {
    throw new Error('getRendererType must be implemented by subclass');
  }
}